// extracted by mini-css-extract-plugin
export default {"content":"AnnotationsMenu_content__6pADw"};